// // import {
// //   Card,
// //   CardContent,
// //   Typography,
// //   Chip,
// //   Box,
// //   Button,
// //   Divider,
// //   alpha,
// // } from "@mui/material";
// // import PeopleIcon from "@mui/icons-material/People";
// // import TimelineIcon from "@mui/icons-material/Timeline";
// // import WorkIcon from "@mui/icons-material/Work";
// // import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// // import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// // const BLUE = {
// //   50: "#eff6ff",
// //   100: "#dbeafe",
// //   200: "#bfdbfe",
// //   300: "#93c5fd",
// //   400: "#60a5fa",
// //   500: "#3b82f6",
// //   600: "#2563eb",
// //   700: "#1d4ed8",
// //   800: "#1e40af",
// // };

// // const JobCard = ({ job, onViewCandidates }) => {
// //   const formatDate = (dateString) => {
// //     if (!dateString) return "N/A";
// //     return new Date(dateString).toLocaleDateString("en-US", {
// //       year: "numeric",
// //       month: "short",
// //       day: "numeric",
// //     });
// //   };

// //   return (
// //     <Card
// //       sx={{
// //         borderRadius: "20px",
// //         transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)",
// //         cursor: "pointer",
// //         height: "100%",
// //         display: "flex",
// //         flexDirection: "column",
// //         // background:
// //         //   "linear-gradient(135deg, #d6f4f8 0%, #dff6f9 50%, #fff 100%)",
// //         bgcolor: "#fff",
// //         border: "2px solid #0c8a9b2d",
// //         boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
// //         "&:hover": {
// //           transform: "translateY(-6px)",
// //           boxShadow: `0 20px 35px -12px ${alpha(
// //             "#0c8a9b",
// //             0.15,
// //           )}, 0 4px 12px rgba(0,0,0,0.05)`,
// //           borderColor: BLUE[300],
// //         },
// //       }}
// //       onClick={onViewCandidates}
// //     >
// //       <CardContent sx={{ p: 2.5, flex: 1 }}>
// //         <Box
// //           sx={{
// //             display: "flex",
// //             justifyContent: "space-between",
// //             alignItems: "flex-start",
// //             mb: 2,
// //           }}
// //         >
// //           <Typography
// //             variant="h6"
// //             sx={{
// //               fontWeight: 700,
// //               fontSize: "1.1rem",
// //               lineHeight: 1.3,
// //               color: "#026875 ",
// //             }}
// //           >
// //             {job.title}
// //           </Typography>
// //           <Chip
// //             label={job.status}
// //             size="small"
// //             sx={{
// //               bgcolor: job.status === "ACTIVE" ? "#0c8a9b " : "#dc2626",
// //               color: "#fff",
// //               fontWeight: 600,
// //               fontSize: "0.7rem",
// //               borderRadius: "20px",
// //               px: 1,
// //             }}
// //           />
// //         </Box>

// //         <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 2 }}>
// //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// //             <WorkIcon sx={{ fontSize: 18, color: "#64748b" }} />
// //             <Typography variant="body2" color="text.secondary">
// //               {job.employment_type || "Full Time"}
// //             </Typography>
// //           </Box>

// //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// //             <AttachMoneyIcon sx={{ fontSize: 18, color: "#64748b" }} />
// //             <Typography variant="body2" color="text.secondary">
// //               {job.salary_min && job.salary_max
// //                 ? `₹${job.salary_min.toLocaleString()} – ₹${job.salary_max.toLocaleString()}`
// //                 : "Salary not specified"}
// //             </Typography>
// //           </Box>

// //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// //             <PeopleIcon sx={{ fontSize: 18, color: "#64748b" }} />
// //             <Typography variant="body2" color="text.secondary">
// //               {job.candidate_count || 0} Candidates
// //             </Typography>
// //           </Box>

// //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// //             <TimelineIcon sx={{ fontSize: 18, color: "#64748b" }} />
// //             <Typography variant="body2" color="text.secondary">
// //               {job.stage_count || 0} Stages
// //             </Typography>
// //           </Box>

// //           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
// //             <CalendarTodayIcon sx={{ fontSize: 18, color: "#64748b" }} />
// //             <Typography variant="body2" color="text.secondary">
// //               Created: {formatDate(job.created_at)}
// //             </Typography>
// //           </Box>
// //         </Box>

// //         <Divider sx={{ my: 2, borderColor: "#e2e8f0" }} />

// //         <Button
// //           variant="outlined"
// //           fullWidth
// //           sx={{
// //             borderRadius: "40px",
// //             textTransform: "none",
// //             fontWeight: 600,
// //             borderColor: "#0c8a9b",
// //             color: "#0c8a9b",

// //             "&:hover": {
// //               borderColor: "#057f8f",
// //               backgroundColor: alpha("#0c8a9b", 0.05),
// //               transform: "translateY(-2px)",
// //             },
// //             transition: "all 0.2s",
// //           }}
// //         >
// //           View Candidates
// //         </Button>
// //       </CardContent>
// //     </Card>
// //   );
// // };

// // export default JobCard;

// import {
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   Box,
//   Button,
//   Divider,
//   alpha,
//   IconButton,
// } from "@mui/material";
// import PeopleIcon from "@mui/icons-material/People";
// import TimelineIcon from "@mui/icons-material/Timeline";
// import WorkIcon from "@mui/icons-material/Work";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import EditIcon from "@mui/icons-material/Edit";

// const BLUE = {
//   50: "#eff6ff",
//   100: "#dbeafe",
//   200: "#bfdbfe",
//   300: "#93c5fd",
//   400: "#60a5fa",
//   500: "#3b82f6",
//   600: "#2563eb",
//   700: "#1d4ed8",
//   800: "#1e40af",
// };

// const JobCard = ({ job, onViewCandidates, onEdit }) => {
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   return (
//     <Card
//       sx={{
//         borderRadius: "20px",
//         transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)",
//         cursor: "pointer",
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#fff",
//         border: "2px solid #0c8a9b2d",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
//         "&:hover": {
//           transform: "translateY(-6px)",
//           boxShadow: `0 20px 35px -12px ${alpha(
//             "#0c8a9b",
//             0.15,
//           )}, 0 4px 12px rgba(0,0,0,0.05)`,
//           borderColor: BLUE[300],
//         },
//       }}
//       onClick={onViewCandidates}
//     >
//       <CardContent sx={{ p: 2.5, flex: 1 }}>
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             mb: 2,
//           }}
//         >
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 700,
//               fontSize: "1.1rem",
//               lineHeight: 1.3,
//               color: "#026875 ",
//             }}
//           >
//             {job.title}
//           </Typography>
//           <Box sx={{ display: "flex", gap: 1 }}>
//             <Chip
//               label={job.status}
//               size="small"
//               sx={{
//                 bgcolor: job.status === "ACTIVE" ? "#0c8a9b " : "#dc2626",
//                 color: "#fff",
//                 fontWeight: 600,
//                 fontSize: "0.7rem",
//                 borderRadius: "20px",
//                 px: 1,
//               }}
//             />
//             {onEdit && (
//               <IconButton
//                 size="small"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   onEdit(job);
//                 }}
//                 sx={{
//                   color: "#0c8a9b",
//                   bgcolor: alpha("#0c8a9b", 0.1),
//                   "&:hover": { bgcolor: alpha("#0c8a9b", 0.2) },
//                 }}
//               >
//                 <EditIcon fontSize="small" />
//               </IconButton>
//             )}
//           </Box>
//         </Box>

//         <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 2 }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <WorkIcon sx={{ fontSize: 18, color: "#64748b" }} />
//             <Typography variant="body2" color="text.secondary">
//               {job.employment_type || "Full Time"}
//             </Typography>
//           </Box>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <AttachMoneyIcon sx={{ fontSize: 18, color: "#64748b" }} />
//             <Typography variant="body2" color="text.secondary">
//               {job.salary_min && job.salary_max
//                 ? `₹${job.salary_min.toLocaleString()} – ₹${job.salary_max.toLocaleString()}`
//                 : "Salary not specified"}
//             </Typography>
//           </Box>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <PeopleIcon sx={{ fontSize: 18, color: "#64748b" }} />
//             <Typography variant="body2" color="text.secondary">
//               {job.candidate_count || 0} Candidates
//             </Typography>
//           </Box>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <TimelineIcon sx={{ fontSize: 18, color: "#64748b" }} />
//             <Typography variant="body2" color="text.secondary">
//               {job.stage_count || 0} Stages
//             </Typography>
//           </Box>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//             <CalendarTodayIcon sx={{ fontSize: 18, color: "#64748b" }} />
//             <Typography variant="body2" color="text.secondary">
//               Created: {formatDate(job.created_at)}
//             </Typography>
//           </Box>
//         </Box>

//         <Divider sx={{ my: 2, borderColor: "#e2e8f0" }} />

//         <Button
//           variant="outlined"
//           fullWidth
//           sx={{
//             borderRadius: "40px",
//             textTransform: "none",
//             fontWeight: 600,
//             borderColor: "#0c8a9b",
//             color: "#0c8a9b",
//             "&:hover": {
//               borderColor: "#057f8f",
//               backgroundColor: alpha("#0c8a9b", 0.05),
//               transform: "translateY(-2px)",
//             },
//             transition: "all 0.2s",
//           }}
//         >
//           View Candidates
//         </Button>
//       </CardContent>
//     </Card>
//   );
// };

// // export default JobCard;
// import {
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   Box,
//   Button,
//   Divider,
//   alpha,
//   IconButton,
// } from "@mui/material";
// import PeopleIcon from "@mui/icons-material/People";
// import TimelineIcon from "@mui/icons-material/Timeline";
// import WorkIcon from "@mui/icons-material/Work";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import EditIcon from "@mui/icons-material/Edit";

// const STYLE_ID = "jc-card-styles";
// if (typeof document !== "undefined" && !document.getElementById(STYLE_ID)) {
//   const s = document.createElement("style");
//   s.id = STYLE_ID;
//   s.textContent = `
//     @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Syne:wght@700&display=swap');
//     .jc-card {
//       border-radius: 14px !important;
//       border: 1px solid rgba(12,138,155,0.12) !important;
//       background: #ffffff !important;
//       box-shadow: 0 1px 6px rgba(0,0,0,0.04) !important;
//       transition: transform 0.2s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.2s ease, border-color 0.18s ease !important;
//       cursor: pointer; overflow: hidden; position: relative;
//       height: 100%; display: flex; flex-direction: column;
//     }
//     .jc-card::before {
//       content: ''; position: absolute; top: 0; left: 0; right: 0;
//       height: 2.5px;
//       background: linear-gradient(90deg, #0c8a9b, #0e9aad);
//       opacity: 0; transition: opacity 0.18s;
//     }
//     .jc-card:hover { transform: translateY(-4px) !important; box-shadow: 0 12px 28px -10px rgba(12,138,155,0.2), 0 3px 8px rgba(0,0,0,0.05) !important; border-color: rgba(12,138,155,0.26) !important; }
//     .jc-card:hover::before { opacity: 1; }
//     .jc-mrow { display: flex; align-items: center; gap: 7px; padding: 3.5px 0; }
//     .jc-micon { width: 22px; height: 22px; border-radius: 5px; background: rgba(12,138,155,0.07); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
//     .jc-btn {
//       border-radius: 40px !important; text-transform: none !important;
//       font-family: 'DM Sans', sans-serif !important; font-weight: 600 !important;
//       font-size: 12.5px !important; border-color: #0c8a9b !important;
//       color: #0c8a9b !important; padding: 5px 0 !important; transition: all 0.18s !important;
//     }
//     .jc-btn:hover { background: rgba(12,138,155,0.06) !important; transform: translateY(-1px) !important; box-shadow: 0 3px 10px rgba(12,138,155,0.14) !important; }
//     .jc-edit { width: 24px !important; height: 24px !important; border-radius: 6px !important; background: rgba(12,138,155,0.08) !important; color: #0c8a9b !important; transition: background 0.13s !important; padding: 0 !important; }
//     .jc-edit:hover { background: rgba(12,138,155,0.16) !important; }
//   `;
//   document.head.appendChild(s);
// }

// const TEAL = "#0c8a9b";

// const MetaRow = ({ icon: Icon, children }) => (
//   <div className="jc-mrow">
//     <div className="jc-micon">
//       <Icon sx={{ fontSize: 13, color: TEAL }} />
//     </div>
//     <Typography
//       sx={{
//         fontSize: "12.5px",
//         color: "#475569",
//         fontFamily: "'DM Sans', sans-serif",
//         lineHeight: 1.3,
//       }}
//     >
//       {children}
//     </Typography>
//   </div>
// );

// const JobCard = ({ job, onViewCandidates, onEdit }) => {
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   const isActive = job.status === "ACTIVE";

//   return (
//     <Card className="jc-card" onClick={onViewCandidates}>
//       <CardContent
//         sx={{
//           p: "14px 15px",
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//           gap: "10px",
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             gap: "6px",
//           }}
//         >
//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography
//               sx={{
//                 fontFamily: "'Syne', sans-serif",
//                 fontWeight: 700,
//                 fontSize: "14.5px",
//                 color: "#065f6e",
//                 lineHeight: 1.3,
//                 letterSpacing: "-0.15px",
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               {job.title}
//             </Typography>
//             <Box
//               sx={{
//                 width: 22,
//                 height: 2,
//                 borderRadius: 2,
//                 mt: "4px",
//                 bgcolor: isActive ? TEAL : "#dc2626",
//                 opacity: 0.45,
//               }}
//             />
//           </Box>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: "5px",
//               flexShrink: 0,
//             }}
//           >
//             <Chip
//               label={isActive ? "Active" : job.status}
//               size="small"
//               sx={{
//                 bgcolor: isActive
//                   ? "rgba(12,138,155,0.09)"
//                   : "rgba(220,38,38,0.08)",
//                 color: isActive ? "#065f6e" : "#991b1b",
//                 fontFamily: "'DM Sans', sans-serif",
//                 fontWeight: 600,
//                 fontSize: "10.5px",
//                 height: 20,
//                 borderRadius: "5px",
//                 border: `1px solid ${
//                   isActive ? "rgba(12,138,155,0.18)" : "rgba(220,38,38,0.18)"
//                 }`,
//                 "& .MuiChip-label": { px: "7px" },
//               }}
//             />
//             {onEdit && (
//               <IconButton
//                 className="jc-edit"
//                 size="small"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   onEdit(job);
//                 }}
//               >
//                 <EditIcon sx={{ fontSize: 13 }} />
//               </IconButton>
//             )}
//           </Box>
//         </Box>

//         {/* Meta */}
//         <Box>
//           <MetaRow icon={WorkIcon}>
//             {job.employment_type || "Full Time"}
//           </MetaRow>
//           <MetaRow icon={AttachMoneyIcon}>
//             {job.salary_min && job.salary_max
//               ? `₹${job.salary_min.toLocaleString()} – ₹${job.salary_max.toLocaleString()}`
//               : "Salary not specified"}
//           </MetaRow>
//           <MetaRow icon={CalendarTodayIcon}>
//             {formatDate(job.created_at)}
//           </MetaRow>
//         </Box>

//         {/* Stats */}
//         <Box
//           sx={{
//             display: "flex",
//             px: "10px",
//             py: "8px",
//             bgcolor: "rgba(12,138,155,0.04)",
//             borderRadius: "8px",
//             border: "1px solid rgba(12,138,155,0.08)",
//           }}
//         >
//           {[
//             {
//               num: job.candidate_count || 0,
//               lbl: "Candidates",
//               icon: PeopleIcon,
//             },
//             { num: job.stage_count || 0, lbl: "Stages", icon: TimelineIcon },
//           ].map((s, i) => (
//             <Box
//               key={i}
//               sx={{
//                 flex: 1,
//                 textAlign: "center",
//                 ...(i === 0 && {
//                   borderRight: "1px solid rgba(12,138,155,0.1)",
//                 }),
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontFamily: "'Syne', sans-serif",
//                   fontWeight: 700,
//                   fontSize: "16px",
//                   color: "#065f6e",
//                   lineHeight: 1,
//                 }}
//               >
//                 {s.num}
//               </Typography>
//               <Typography
//                 sx={{
//                   fontSize: "9px",
//                   color: "#94a3b8",
//                   fontFamily: "'DM Sans', sans-serif",
//                   mt: "2px",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.7px",
//                 }}
//               >
//                 {s.lbl}
//               </Typography>
//             </Box>
//           ))}
//         </Box>

//         <Divider sx={{ borderColor: "rgba(226,232,240,0.6)" }} />

//         <Button variant="outlined" fullWidth className="jc-btn">
//           View Candidates →
//         </Button>
//       </CardContent>
//     </Card>
//   );
// };

// export default JobCard;
// // components/JobCard.js – Redesigned to match Hiring Bible reference UI
// import {
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   Box,
//   IconButton,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";

// const STYLE_ID = "hb-jobcard-styles";
// if (typeof document !== "undefined" && !document.getElementById(STYLE_ID)) {
//   const s = document.createElement("style");
//   s.id = STYLE_ID;
//   s.textContent = `
//     @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

//     :root {
//       --hb-teal: #0d9488;
//       --hb-teal-light: rgba(13,148,136,0.1);
//       --hb-font: 'Inter', -apple-system, sans-serif;
//     }

//     .hb-card {
//       border-radius: 16px !important;
//       border: 1px solid #e5e7eb !important;
//       background: #ffffff !important;
//       box-shadow: 0 1px 4px rgba(0,0,0,0.04) !important;
//       transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.18s ease !important;
//       cursor: pointer;
//       overflow: hidden;
//       height: 100%;
//       display: flex;
//       flex-direction: column;
//     }

//     .hb-card:hover {
//       transform: translateY(-2px) !important;
//       box-shadow: 0 8px 24px rgba(0,0,0,0.08) !important;
//       border-color: #d1d5db !important;
//     }

//     /* Status badge */
//     .hb-status-active {
//       display: inline-flex;
//       align-items: center;
//       gap: 5px;
//       background: rgba(13,148,136,0.08);
//       color: #0d9488;
//       border: 1px solid rgba(13,148,136,0.2);
//       border-radius: 20px;
//       padding: 3px 8px;
//       font-family: var(--hb-font);
//       font-size: 11.5px;
//       font-weight: 500;
//     }

//     .hb-status-closed {
//       display: inline-flex;
//       align-items: center;
//       gap: 5px;
//       background: rgba(107,114,128,0.08);
//       color: #6b7280;
//       border: 1px solid rgba(107,114,128,0.2);
//       border-radius: 20px;
//       padding: 3px 8px;
//       font-family: var(--hb-font);
//       font-size: 11.5px;
//       font-weight: 500;
//     }

//     .hb-status-dot {
//       width: 6px;
//       height: 6px;
//       border-radius: 50%;
//       flex-shrink: 0;
//     }

//     .hb-status-dot-active { background: #0d9488; }
//     .hb-status-dot-closed { background: #9ca3af; }

//     /* Job title */
//     .hb-job-title {
//       font-family: var(--hb-font) !important;
//       font-weight: 800 !important;
//       font-size: 20px !important;
//       color: #111827 !important;
//       line-height: 1.2 !important;
//       letter-spacing: -0.3px !important;
//       margin: 8px 0 10px !important;
//     }

//     /* Tag pills */
//     .hb-tag {
//       display: inline-flex;
//       align-items: center;
//       background: #f3f4f6;
//       color: #374151;
//       border-radius: 6px;
//       padding: 3px 9px;
//       font-family: var(--hb-font);
//       font-size: 12px;
//       font-weight: 500;
//     }

//     /* Stats grid */
//     .hb-stats {
//       display: grid;
//       grid-template-columns: 1fr 1fr;
//       gap: 8px;
//       margin: 12px 0;
//     }

//     .hb-stat-box {
//       background: #f9fafb;
//       border-radius: 10px;
//       padding: 10px 12px;
//     }

//     .hb-stat-label {
//       font-family: var(--hb-font);
//       font-size: 10px;
//       font-weight: 600;
//       color: #9ca3af;
//       text-transform: uppercase;
//       letter-spacing: 0.6px;
//       margin-bottom: 4px;
//     }

//     .hb-stat-value {
//       font-family: var(--hb-font);
//       font-size: 22px;
//       font-weight: 700;
//       color: #111827;
//       line-height: 1;
//     }

//     /* Footer */
//     .hb-card-footer {
//       display: flex;
//       align-items: center;
//       justify-content: space-between;
//       padding-top: 10px;
//       border-top: 1px solid #f3f4f6;
//       margin-top: auto;
//     }

//     .hb-posted-date {
//       font-family: var(--hb-font);
//       font-size: 12px;
//       color: #9ca3af;
//     }

//     .hb-view-link {
//       font-family: var(--hb-font);
//       font-size: 13px;
//       font-weight: 600;
//       color: var(--hb-teal);
//       background: none;
//       border: none;
//       cursor: pointer;
//       padding: 0;
//       transition: opacity 0.15s;
//       text-decoration: none;
//     }

//     .hb-view-link:hover { opacity: 0.75; }

//     .hb-edit-btn {
//       width: 28px !important;
//       height: 28px !important;
//       border-radius: 7px !important;
//       background: #f3f4f6 !important;
//       color: #6b7280 !important;
//       transition: background 0.12s !important;
//       padding: 0 !important;
//     }

//     .hb-edit-btn:hover {
//       background: #e5e7eb !important;
//       color: #374151 !important;
//     }
//   `;
//   document.head.appendChild(s);
// }

// const JobCard = ({ job, onViewCandidates, onEdit }) => {
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   const isActive = job.status === "ACTIVE";

//   const formatSalary = () => {
//     if (job.salary_min && job.salary_max) {
//       const fmt = (n) => {
//         if (n >= 100000) return `₹${Math.round(n / 100000)}L`;
//         return `₹${(n / 1000).toFixed(0)}k`;
//       };
//       return `${fmt(job.salary_min)} – ${fmt(job.salary_max)}`;
//     }
//     return null;
//   };

//   return (
//     <Card className="hb-card" onClick={onViewCandidates}>
//       <CardContent
//         sx={{
//           p: "18px 20px",
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         {/* Top row: status badge + edit */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <span className={isActive ? "hb-status-active" : "hb-status-closed"}>
//             <span
//               className={`hb-status-dot ${
//                 isActive ? "hb-status-dot-active" : "hb-status-dot-closed"
//               }`}
//             />
//             {isActive ? "Active" : job.status}
//           </span>
//           {onEdit && (
//             <IconButton
//               className="hb-edit-btn"
//               size="small"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onEdit(job);
//               }}
//             >
//               <EditIcon sx={{ fontSize: 14 }} />
//             </IconButton>
//           )}
//         </Box>

//         {/* Job title */}
//         <Typography className="hb-job-title">{job.title}</Typography>

//         {/* Tags: employment type + salary */}
//         <Box sx={{ display: "flex", gap: "6px", flexWrap: "wrap", mb: 1 }}>
//           {job.employment_type && (
//             <span className="hb-tag">
//               {job.employment_type === "FULL_TIME"
//                 ? "Full-time"
//                 : job.employment_type === "PART_TIME"
//                 ? "Part-time"
//                 : job.employment_type === "CONTRACT"
//                 ? "Contract"
//                 : job.employment_type === "INTERNSHIP"
//                 ? "Internship"
//                 : job.employment_type}
//             </span>
//           )}
//           {job.location && <span className="hb-tag">{job.location}</span>}
//           {formatSalary() && <span className="hb-tag">{formatSalary()}</span>}
//         </Box>

//         {/* Stats */}
//         <div className="hb-stats">
//           <div className="hb-stat-box">
//             <div className="hb-stat-label">Candidates</div>
//             <div className="hb-stat-value">{job.candidate_count || 0}</div>
//           </div>
//           <div className="hb-stat-box">
//             <div className="hb-stat-label">Hiring Stages</div>
//             <div className="hb-stat-value">
//               {job.stage_count ? `${job.stage_count} Stages` : "0"}
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="hb-card-footer">
//           <span className="hb-posted-date">
//             {isActive ? "Posted" : "Ended"} {formatDate(job.created_at)}
//           </span>
//           <button
//             className="hb-view-link"
//             onClick={(e) => {
//               e.stopPropagation();
//               onViewCandidates();
//             }}
//           >
//             {isActive ? "View Candidates →" : "Review Archive →"}
//           </button>
//         </div>
//       </CardContent>
//     </Card>
//   );
// };

// export default JobCard;
// REPLACE ONLY YOUR JOBCARD.jsx WITH THIS
// functionality untouched
// only UI updated smaller + initials avatar + candidate & stage counts

import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Avatar,
  AvatarGroup,
} from "@mui/material";

import { useState } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import JobStatusControl from "./JobStatusControl";
import JobCardMenu from "./JobCardMenu";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const STYLE_ID = "hb-job-card-ui-new";

if (typeof document !== "undefined" && !document.getElementById(STYLE_ID)) {
  const style = document.createElement("style");

  style.id = STYLE_ID;

  style.textContent = `

  :root{
    --hb-primary:#0b8a8f;
    --hb-border:#e9edf5;
    --hb-text:#101828;
    --hb-muted:#667085;
    --hb-font:'Inter',sans-serif;
  }

  .hb-job-card{
    border-radius:22px !important;
    border:1px solid var(--hb-border) !important;
    background:#fff !important;
    box-shadow:0 3px 14px rgba(16,24,40,.04) !important;
    transition:.22s ease !important;
    overflow:hidden;
    height:100%;
    cursor:pointer;
  }

  .hb-job-card:hover{
    transform:translateY(-3px);
    box-shadow:0 10px 24px rgba(16,24,40,.08) !important;
  }

  .hb-job-category{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    padding:5px 10px;
    border-radius:999px;
    background:#ecfdff;
    color:#0b8a8f;
    font-size:10px;
    font-weight:700;
    font-family:var(--hb-font);
  }

  .hb-job-status{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    padding:5px 10px;
    border-radius:999px;
    background:#dcfce7;
    color:#16a34a;
    font-size:10px;
    font-weight:700;
    font-family:var(--hb-font);
  }

  .hb-job-status-closed{
    background:#f2f4f7;
    color:#667085;
  }

  .hb-job-title{
    font-size:1.65rem !important;
    line-height:1.15 !important;
    letter-spacing:-0.5px !important;
    font-weight:800 !important;
    color:var(--hb-text) !important;
    font-family:var(--hb-font) !important;
    margin-bottom:10px !important;
  }

  .hb-job-subtitle{
    font-size:14px !important;
    color:var(--hb-muted) !important;
    font-family:var(--hb-font) !important;
    line-height:1.5 !important;
    margin-bottom:24px !important;
  }

  .hb-job-footer{
    display:flex;
    justify-content:space-between;
    align-items:flex-end;
    margin-top:auto;
    gap:16px;
  }

  .hb-job-stat-wrap{
    display:flex;
    align-items:flex-end;
    gap:20px;
  }

  .hb-job-stat-box{
    display:flex;
    flex-direction:column;
    align-items:flex-end;
  }

  .hb-job-stat-value{
    font-size:28px;
    line-height:1;
    font-weight:800;
    color:var(--hb-text);
    font-family:var(--hb-font);
  }

  .hb-job-stat-label{
    font-size:11px;
    color:#98a2b3;
    font-weight:700;
    text-transform:uppercase;
    letter-spacing:.06em;
    font-family:var(--hb-font);
    margin-top:4px;
  }

  .hb-job-edit-btn{
    width:34px !important;
    height:34px !important;
    border-radius:11px !important;
    background:#f2f4f7 !important;
    color:#667085 !important;
  }

  .hb-job-edit-btn:hover{
    background:#e4e7ec !important;
  }

  `;
  document.head.appendChild(style);
}

const JobCard = ({ job, onViewCandidates, onEdit, onChanged }) => {
  // True while the card's own menu or one of its confirmations is open. The
  // whole card is a link, and a click that lands on a dialog must never also
  // count as a click on the thing behind it.
  const [menuOpen, setMenuOpen] = useState(false);

  // initials for avatars
  const getInitials = (name) => {
    if (!name) return "C";

    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();
  };

  // fake preview candidates
  // only for UI display
  const previewCandidates = job.candidates?.slice(0, 4) || [
    { name: "Alex " },
    { name: "Sarah " },
    { name: "John " },
    { name: "Emily" },
  ];

  return (
    <Card
      className="hb-job-card"
      onClick={() => {
        if (menuOpen) return;
        onViewCandidates?.();
      }}
    >
      <CardContent
        sx={{
          p: 2.5,
          display: "flex",
          flexDirection: "column",
          minHeight: 220,
        }}
      >
        {/* TOP */}

        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "space-between",
            }}
          >
            {" "}
            {/* Was 25. The row now carries a status control and a menu
                beside it, and at 25 a two-word title pushed them onto a second
                line. Long titles wrap to at most two lines rather than
                stretching the card. */}
            <Typography
              sx={{
                fontSize: 19,
                fontWeight: 700,
                lineHeight: 1.3,
                minWidth: 0,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {job.title}
            </Typography>
            <Box sx={{ display: "flex", gap: 0.5, alignItems: "center", flexShrink: 0 }}>
              {/* The badge was already here saying whether the job was open.
                  Making it the control puts the switch where the answer
                  already is, rather than adding a second place to look.

                  Wrapped so its clicks never reach the card, which navigates
                  on any click anywhere. */}
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
                sx={{ display: "flex" }}
              >
                <JobStatusControl
                  jobId={job.id}
                  status={job.status}
                  onChange={() => onChanged?.()}
                />
              </Box>

              {onEdit && (
                <IconButton
                  className="hb-job-edit-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit(job);
                  }}
                >
                  <EditOutlinedIcon sx={{ fontSize: 16 }} />
                </IconButton>
              )}

              <JobCardMenu job={job} onChanged={onChanged} onOpenChange={setMenuOpen} />
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flex: 1,
            justifyContent: "space-between",
            gap: 1,
            alignItems: "center",
          }}
        >
          {/* candidates */}
          <Box
            sx={{
              textAlign: "center",
              width: "50%",
              bgcolor: "#f3f3f3",
              borderRadius: 0.4,
              p: 0.5,
            }}
          >
            <Typography sx={{ fontSize: 20, fontWeight: 700 }}>
              {job.candidate_count || 0}
            </Typography>

            <Box>Candidates</Box>
          </Box>

          {/* stages */}
          <Box
            sx={{
              textAlign: "center",
              width: "50%",
              bgcolor: "#f3f3f3",
              borderRadius: 0.4,
              p: 0.5,
            }}
          >
            <Typography sx={{ fontSize: 20, fontWeight: 700 }}>
              {job.stage_count || 0}
            </Typography>

            <Box>Stages</Box>
          </Box>
        </Box>

        {/* FOOTER */}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <AvatarGroup
            max={4}
            sx={{
              "& .MuiAvatar-root": {
                width: 30,
                height: 30,
                fontSize: 11,
                fontWeight: 700,
                color: "#fff",
                border: "2px solid #fff",
                background: "#0b8a8f",
              },
            }}
          >
            {previewCandidates.map((candidate, idx) => (
              <Avatar key={idx}>{getInitials(candidate.name)}</Avatar>
            ))}
          </AvatarGroup>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: "#0b8a8f",
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
              transition: ".2s ease",
              "&:hover": {
                opacity: 0.75,
                transform: "translateX(2px)",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 700,
                color: "#0b8a8f",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              View Candidates
            </Typography>

            <ArrowForwardIcon sx={{ fontSize: 16 }} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default JobCard;
